import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsFormsKioskSvg = lazy(() => import('./svg-components/digital-forms-forms-kiosk-svg'));

const DigitalFormsFormsKioskSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsFormsKioskSvg {...rest} />
  </Suspense>
);

export default DigitalFormsFormsKioskSvg;
